<template>
  <div class="fabric" id="container">
    <div class="fabric-container">
      <div class="fabric_mask">
        <div class="fab_title">
          <div style="width: 550px; height: 100%; margin-left: 10px;">
            <div v-show="showBIM" style="width: 550px; height: 100%; display: flex; align-items: center">
              <div style="width: 250px; height: 100%">
                <el-dropdown v-show="showBIM" trigger="click" @command="handleTemplate1">
                  <el-button
                    style="font-size: 1rem; width: 250px; display: flex;background-color: transparent;border-width: 0px">
                    <div
                      style="width: 235px; height: 1rem; text-align: left; white-space: nowrap;text-overflow: ellipsis;overflow: hidden; padding: 0; margin: 0;color: #ccc">
                      {{ template_name }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                  </el-button>
                  <el-dropdown-menu style="transform-origin: left; width: 250px;display: none"
                                    slot="dropdown">
                    <el-dropdown-item
                      style="font-size: 1rem;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
                      v-for="(template, index) in templates" :command=template
                      :key="'key_t1_' + index">
                      {{ template.template_name }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div style="width: 1px; height: 60%; margin-left: 3px; background-color: white"></div>
              <div style="width: 80px; height: 100%">
                <el-dropdown v-show="showBIM" trigger="click" @command="handleBlock">
                  <el-button
                    style="font-size: 1rem; width: 80px; display: flex;background-color: transparent;border-width: 0px">
                    <div
                      style="width: 75px; height: 1rem; text-align: left; white-space: nowrap;text-overflow: ellipsis;overflow: hidden; padding: 0; margin: 0;color: #ccc">
                      {{ block_name }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                  </el-button>
                  <el-dropdown-menu style="transform-origin: left; width: 80px;display: none"
                                    slot="dropdown">
                    <el-dropdown-item
                      style="font-size: 1rem;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
                      v-for="(block, index) in block_list" :command=block
                      :key="'key_b_' + index">
                      {{ block.block }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div style="width: 1px; height: 60%; margin-left: 3px; background-color: white"></div>
              <div style="width: 80px; height: 100%">
                <el-dropdown v-show="showBIM" trigger="click" @command="handleLevel">
                  <el-button
                    style="font-size: 1rem; width: 80px; display: flex;background-color: transparent;border-width: 0px">
                    <div
                      style="width: 75px; height: 1rem; text-align: left; white-space: nowrap;text-overflow: ellipsis;overflow: hidden; padding: 0; margin: 0;color: #ccc">
                      {{ level_name }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                  </el-button>
                  <el-dropdown-menu style="transform-origin: left; width: 80px;display: none"
                                    slot="dropdown">
                    <el-dropdown-item
                      style="font-size: 1rem;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
                      v-for="(level, index) in level_list" :command=level
                      :key="'key_l_' + index">
                      {{ level }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div style="width: 1px; height: 60%; margin-left: 3px; background-color: white"></div>
              <div style="width: 120px; margin-left: 10px; font-size: 16px; text-align: left; color: white">Quantity:&nbsp;{{
                  all_count
                }}
              </div>
            </div>


          </div>
          <el-radio-group @change="changeTitle" v-model="title">
            <el-radio-button label="BIM"></el-radio-button>
            <el-radio-button label="Block Chart"></el-radio-button>
          </el-radio-group>
          <div style="width: 550px; height: 100%; margin-right: 10px;">
            <!--            <el-dropdown v-show="showBIM" trigger="click" @command="handleTemplate">-->
            <!--              <el-button-->
            <!--                style="font-size: 1rem; width: 250px; margin-left: 300px; display: flex;background-color: transparent;border-width: 0px">-->
            <!--                <div-->
            <!--                  style="width: 235px; height: 1rem; text-align: left; white-space: nowrap;text-overflow: ellipsis;overflow: hidden; padding: 0; margin: 0;color: #ccc">-->
            <!--                  {{ template_name }}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
            <!--                </div>-->
            <!--              </el-button>-->
            <!--              <el-dropdown-menu style="transform-origin: left; width: 250px;display: none"-->
            <!--                                slot="dropdown">-->
            <!--                <el-dropdown-item-->
            <!--                  style="font-size: 1rem;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"-->
            <!--                  v-for="(template, index) in templates" :command=template-->
            <!--                  :key="'key_t_' + index">-->
            <!--                  {{ template.template_name }}-->
            <!--                </el-dropdown-item>-->
            <!--              </el-dropdown-menu>-->
            <!--            </el-dropdown>-->
          </div>
        </div>

        <div v-show="showBIM" style="width: 100%; height: 95%; display: flex; flex-direction: column">
          <div style="width: 100%; height: 58%;margin-bottom: 1%; display: flex">
            <div class="one_top_left">
              <div class="two_top">
                <div class="three_left">
                  <milestones3 :block_list="block_list" :template_id.sync="template_id" :block_name.sync="block_name"
                               :level_name.sync="level_name"
                               :project_id="my_project_id"></milestones3>
                </div>
                <div class="three_right">
                  <milestones1 v-bind:all_stages="all_stages"></milestones1>
                </div>
              </div>
              <div class="two_bottom">
                <milestones2 :global_months="global_months"
                             :all_stages_by_month="all_stages_by_month"></milestones2>
              </div>
            </div>
            <div class="one_top_right">
              <div class="one_top_right_title">
                <el-select style="width: 280px"
                  v-model="selectedModels"
                  placeholder="Select model"
                  multiple
                  collapse-tags>
                  <el-option
                    style="width: 320px; font-size: 1rem;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
                    v-for="(item, index) in canvas_list"
                    :key="'key_d_' + index"
                    :label="item.model_name"
                    :value="item.model_id + '_' + item.version">
                  </el-option>
                </el-select>

                <el-button @click="openModels" style="font-size: 1rem; margin-left: 1rem">Open
                </el-button>
                <el-button @click="closeModels" style="font-size: 1rem;margin-left: 1rem">Close</el-button>
                <el-select
                  style="width: 120px; background-color: white; height: 70%; margin-left: 10px; display: flex; align-items: center;border-radius: 5%"
                  v-model="mouseValue" placeholder="select" @change="mouseChange">
                  <el-option
                    v-for="item in mouseOptions"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
              <div v-loading="loading" class="one_top_right_content">
                <canvas id="View" style="width: 100%; height: 100%"></canvas>
              </div>
            </div>
          </div>
          <div class="one_bottom">
            <div class="one_bottom_legends">
              <div class="legend_item" v-for="(legend, index) in stage_list" v-show="legend.dashboard_flag == '0'"
                   :key="'legend' + index">
                <div class="legend_icon" :style="{backgroundColor: legend.stage_color}"></div>
                <div class="legend_text">{{ legend.stage_name }}</div>
              </div>
            </div>
            <div class="one_bottom_charts">
              <div class="chart_item" v-for="(item,index) in block_datas">
                <div :id="'block_' + index" :key="'key1_' + index" style="height: 100%">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!showBIM" style="width: 100%; height: 95%">
          <iframe style="width: 100%; height: 100%"
                  :src="bl_src"
                  frameborder="0"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import milestones1 from "@/components/fabrication/milestones_1";
import milestones2 from "@/components/fabrication/milestones_2";
import milestones3 from "@/components/fabrication/milestones_3";
import echarts from 'echarts'
import axios from 'axios'

export default {
  name: "quality",
  props: ['project_id'],

  data() {
    return {
      my_project_id: this.project_id,
      tbmCount: [],
      tbmEmpty: true,
      nowTime: '',
      startDate: '2018-08-15',
      startTimes: '',
      container: '',
      title: 'BIM',
      stage_list: [],
      block_list: [],
      models: [],
      block_datas: [],
      level_list: [],
      all_stages: [],
      all_stages_ids: [],
      all_stages_by_month: [],
      global_months: [],
      months: [],
      templates: [],
      template_id: '',
      template_name: '',
      block_name: 'ALL',
      level_name: 'ALL',
      uid: '860',
      token: 'lalala',
      showBIM: true,
      canvas_list: [],
      model_name: '',
      model_id: '',
      view: null,
      data: null,
      selectedModels: [],
      openedModels: [],
      loading: false,
      all_count: 0,
      mouseOptions: [
        'PAN', 'ROTATE', 'PICK'
      ],
      mouseValue: 'PAN',
      LeftMouseOperation: null,
      bl_src: "",
    }
  },
  methods: {
    obj_add(obj1, obj2) {
      for (var i = 0; i < obj1.length; i++) {
        if (obj1[i].month === obj2[i].month) {
          obj1[i].cnt = obj1[i].cnt + obj2[i].cnt
        }
      }
    },
    init() {
      var that = this
      let postData = {
        uid: that.uid, token: that.token, project_id: this.my_project_id
      }
      console.log(postData)
      this.bl_src = that.$store.getters.getServer241Address + "blchart/index.html#/?proj_id=" + this.my_project_id
      axios.post(that.$store.getters.getCmsQaServer + "CMSC0411", postData).then(resp => {
        if (resp.status == 200) {
          if (resp.data.errno == 0) {
            that.templates = resp.data.result
            console.log(that.templates)
            if (that.templates.length > 0) {
              that.template_id = that.templates[0].template_id
              that.template_name = that.templates[0].template_name
              that.getBlocksAndModels()
            } else {
              console.log('No Data!')
            }
          } else {
            console.log(resp.data.errstr)
          }
        } else {
          console.log(resp.statusText)
        }
      }).catch(error => {
        console.log(error)
      })
      let modelData = {
        uid: '860',
        token: 'lalala',
        project_id: this.my_project_id,
        page: 1,
        pagesize: 10000
      }
      axios.post(that.$store.getters.getCmsBimServer + "ProjRevitModelList", modelData).then(resp => {
        if (resp.status == 200) {
          if (resp.data.errno == 0) {
            var canvas_result = resp.data.result
            if (canvas_result && canvas_result.length > 0) {
              that.canvas_list = canvas_result
            } else {
              console.log('No BIM Data!')
            }
          } else {
            console.log(resp.data.errstr)
          }
        } else {
          console.log(resp.statusText)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getBlocksAndModels() {
      var that = this
      let postData = {
        project_id: this.my_project_id,
        template_id: that.template_id,
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token')
      }
      that.block_list = [{block: 'ALL', levels: ['ALL']}]
      axios.post(that.$store.getters.getCmsServer + "DBProjBlocksAndModels", postData).then(resp => {
        if (resp.status == 200) {
          var errno = resp.data.errno
          if (errno == 0) {
            var result = resp.data.result
            var blocks = result.blocks
            var block_names = ['ALL']
            for (var i = 0; i < blocks.length; i++) {
              var block = blocks[i]
              var block_name = block.block
              var level_name = block.level
              var index = block_names.indexOf(block_name)
              if (index < 0) {
                block_names.push(block_name)
                that.block_list.push({
                  block: block_name, levels: [
                    'ALL', level_name
                  ]
                })
              } else {
                that.block_list[index].levels.push(level_name)
              }
            }
            that.models = result.models
            that.block_name = that.block_list[0].block
            that.level_list = this.block_list[0].levels
            that.level_name = that.level_list[0]
            that.getBlocks()
          } else {
            console.log(resp)
          }
        } else {
          console.log(resp.statusText)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getBlocks() {
      var that = this
      var block = ''
      var level = ''
      if (that.block_name != 'ALL') {
        block = that.block_name
      }
      if (that.level_name != 'ALL') {
        level = that.level_name
      }
      let postData = {
        project_id: this.my_project_id,
        template_id: that.template_id,
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token'),
        block: block,
        level: level
      }
      console.log(postData)
      axios.post(that.$store.getters.getCmsServer + "DBProjMilestones_T2", postData).then(resp => {
        if (resp.status == 200) {
          var errno = resp.data.errno
          console.log(resp)
          if (errno == 0) {
            var result = resp.data.result
            that.stage_list = result.stage_list
            var index = -1
            for (var i = 0; i < that.stage_list.length; i++) {
              var stage = that.stage_list[i]
              if (stage.stage_name == 'Not started') {
                index = i
                break
              }
            }
            if (index != -1) {
              var stage = that.stage_list[index]
              that.stage_list.splice(index, 1)
              that.stage_list.push(stage)
            }
            that.block_datas = result.data
            if (result.pbu_count) {
              that.all_count = result.pbu_count
            }
            that.handleData()
            that.$nextTick(() => {
              that.drawBlocks()
            })
          } else {
            console.log(resp.data.errstr)
          }
        } else {
          console.log(resp.statusText)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    changeTitle(title) {
      if (title == 'BIM') {
        this.showBIM = true
      } else {
        this.showBIM = false
      }
    },
    mouseChange(mouse) {
      if (mouse == 'PAN') {
        this.view.getWINDViewRoaming().setLeftMouseOperation(this.LeftMouseOperation.PAN);
      } else if (mouse == 'ROTATE') {
        this.view.getWINDViewRoaming().setLeftMouseOperation(this.LeftMouseOperation.ROTATE);
      } else {
        this.view.getWINDViewRoaming().setLeftMouseOperation(this.LeftMouseOperation.PICK);
      }
    },
    getStagesByMonth() {
      var that = this
      var date = new Date()
      var now_year = date.getFullYear()
      var now_month = date.getMonth()
      var month = 0
      var year = 0
      that.global_months = []
      that.months = []
      that.all_stages_by_month = []
      for (var i = 5; i > -1; i--) {
        if (now_month + 1 > i) {
          month = now_month + 1 - i
          year = now_year
        } else {
          month = now_month + 13 - i
          year = now_year - 1
        }
        that.global_months.push(month + '-' + year)
        if (month < 10) {
          month = '0' + month
        }
        that.months.push(year + '-' + month)
      }
      // var data = {stage_name: 'name1', months: [1, 2, 3, 4, 5, 6]}
      for (var i = 0; i < that.all_stages.length; i++) {
        var stage = that.all_stages[i]
        if (stage.stage_id && stage.stage_name) {
          var stage_dates = stage.stage_dates
          var temp_months = []
          for (var j = 0; j < stage_dates.length; j++) {
            temp_months.push(stage_dates[j].cnt)
          }
          that.all_stages_by_month.push({stage_name: stage.stage_name, months: temp_months})
        }
      }
    },
    counts(arr, value) {
      return arr.reduce((a, v) => v == value ? a + 1 : a + 0, 0)
    },
    handleTemplate(command) {
      if (this.template_id != command.template_id) {
        this.template_id = command.template_id
        this.template_name = command.template_name
        this.getBlocks()
      }
    },
    handleTemplate1(command) {
      if (this.template_id != command.template_id) {
        this.template_id = command.template_id
        this.template_name = command.template_name
        this.getBlocksAndModels()
        // this.getBlocks()
      }
    },
    handleBlock(command) {
      if (this.block_name != command.block) {
        this.block_name = command.block
        this.level_list = command.levels
        this.level_name = this.level_list[0]
        this.getBlocks()
      }
    },
    handleLevel(command) {
      if (this.level_name != command) {
        this.level_name = command
        this.getBlocks()
      }
    },
    handleData() {
      var that = this
      that.all_stages_ids = []
      that.all_stages = []
      for (var k = 0; k < that.stage_list.length; k++) {
        var stage = that.stage_list[k]
        var index = that.all_stages_ids.indexOf(stage.stage_id)
        if (stage.dashboard_flag == '0') {
          if (index < 0) {
            that.all_stages_ids.push(stage.stage_id)
            that.all_stages.push({
              stage_id: stage.stage_id,
              stage_name: stage.stage_name,
              stage_color: stage.stage_color,
              stage_cnt: Number(stage.total),
              stage_dates: stage.month_cnt,
              dashboard_flag: stage.dashboard_flag
            })
          } else {
            that.all_stages[index].stage_cnt += Number(stage.total)
            that.obj_add(that.all_stages[index].stage_dates, stage.month_cnt)
          }
        }
      }
      that.getStagesByMonth()
    },
    drawBlocks() {
      var that = this
      for (var i = 0; i < that.block_datas.length; i++) {
        var block_item = that.block_datas[i]
        var chart_data = []
        var colors = []
        var names = []
        var total = parseInt(block_item.total)
        var block_stages = block_item.stage
        for (var j = 0; j < block_stages.length; j++) {
          var block_stage = block_stages[j]
          if (block_stage.dashboard_flag != '0') {
            continue
          }
          var count = parseInt(block_stage.cnt)
          if (count > 0) {
            for (var k = 0; k < that.stage_list.length; k++) {
              var stage = that.stage_list[k]
              if (block_stage.stage_name == stage.stage_name) {
                var index = names.indexOf(block_stage.stage_name)
                if (index < 0) {
                  names.push(block_stage.stage_name)
                  chart_data.push({
                    value: parseInt(block_stage.cnt), name: block_stage.stage_name
                  })
                  colors.push(block_stage.stage_color)
                } else {
                  chart_data[index].value = chart_data[index].value + parseInt(block_stage.cnt)
                }
              }
            }
          }
        }
        let chart = echarts.init(document.getElementById('block_' + i))
        chart.setOption({
          graphic: {       //图形中间文字
            elements: [
              {
                type: "circle",
                shape: {
                  cx: 120,
                  cy: 105,
                  r: 50
                },
                style: {
                  fill: "#FFFFFF",
                }
              },
              {
                type: "text",
                left: "center",
                top: "center",
                style: {
                  text: 'Block ' + block_item.block + '\n' + '(' + block_item.total + ')',
                  textAlign: "center",
                  fill: "black",
                  fontSize: 16
                }
              }
            ]
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
            confine: true,
            textStyle: {
              fontSize: 12
            }
          },
          series: [{
            name: block_item.block,
            type: 'pie',
            radius: ['45%', '70%'],
            data: chart_data,
            label: {
              normal: {
                show: true,
                position: 'inner',
                formatter: '{c}',
                textStyle: {
                  fontSize: 12,
                  color: 'black'
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: 14,
                }
              }
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  return colors[params.dataIndex]
                }
              },
              //鼠标悬停时：
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
                borderWidth: 1,
              }
            },
          }]
        })
      }
    },
    async openModels() {
      var that = this
      this.loading = true
      var models = []
      var temp = []
      var shouldCloseModels = []
      var shouldOpenModels = []
      this.openedModels.forEach(model => {
        if (this.selectedModels.indexOf(model) < 0) {
          var spl = model.split('_')
          shouldCloseModels.push({
            modelId: spl[0],
            version: spl[1]
          })
        }
      })
      this.selectedModels.forEach(model => {
        if (this.openedModels.indexOf(model) < 0) {
          this.openedModels.push(model)
          shouldOpenModels.push(model)
        }
        var spl = model.split('_')
        temp.push(model)
        models.push({
          modelId: spl[0],
          version: spl[1]
        })
      })
      //  关闭部分model时报错
      // this.data.getWINDDataLoader().closeModelDatas(shouldCloseModels)
      await this.data.getWINDDataLoader().openModelDatas(models, true)
      this.openedModels = temp
      this.view.getWINDViewControl().clearAllBatchEntities()
      var component_list = await this.data.getWINDDataQuerier().getAllComponentParameterL(true);
      var alpha = Number(111)
      for (let key in component_list) {
        var uuid_list = new Array();
        var parameter = component_list[key].parameter;
        var i = 0;
        var batch_id = component_list[key].modelId;
        for (let index in parameter) {
          uuid_list[i] = parameter[index].uuid;
          i++;
        }
        var status = this.view.getWINDViewControl().createBatchEntities(batch_id, uuid_list);
        if (status == true) {
          var values = this.convertHexToRGB('#D7D7D7')
          await this.view.getWINDViewControl().coloringBatchEntities(batch_id, values.r, values.g, values.b, 255);
        }
      }
      shouldOpenModels.forEach(openModel => {
        var model_id = openModel.split('_')[0]
        for (var i = 0; i < this.models.length; i++) {
          var model = this.models[i]
          if (model.model_id == model_id) {
            var models = model.models
            var colors = []
            var guids = []
            models.forEach(model => {
              var color = model.color
              var guid = model.guid
              var index = colors.indexOf(color)
              if (index < 0) {
                colors.push(color)
                guids.push([guid])
              } else {
                guids[index].push(guid)
              }
            })
            guids.forEach((guidSet, index) => {
              var batch_id = model_id + '_' + colors[index]
              var status = this.view.getWINDViewControl().createBatchEntities(batch_id, guidSet)
              if (status) {
                var values = this.convertHexToRGB(colors[index])
                this.view.getWINDViewControl().coloringBatchEntities(batch_id, values.r, values.g, values.b, 255)
              }
            })
            break
          }
        }
      })
      this.loading = false
    },
    closeModels() {
      this.view.getWINDViewControl().clearAllBatchEntities()
      this.data.getWINDDataLoader().closeAllModelDatas();
      this.selectedModels = []
      this.openedModels = []
    },
    convertHexToRGB(color) {
      if (color.length === 4) {
        let extendedColor = "#"
        for (let i = 1; i < color.length; i++) {
          extendedColor += color.charAt(i) + color.charAt(i)
        }
        color = extendedColor
      }
      const values = {
        r: parseInt(color.substr(1, 2), 16),
        g: parseInt(color.substr(3, 2), 16),
        b: parseInt(color.substr(5, 2), 16),
      }
      return values
    }
  },
  components: {milestones1, milestones2, milestones3},
  created() {
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    this.init()
  },
  mounted() {
    let WINDData = WIND.WINDData;
    let WINDView = WIND.WINDView;
    this.LeftMouseOperation = WIND.LeftMouseOperation;

    //WINDData初始化
    let config = {};
    // config.serverIp = 'https://bim.cmstech.sg';
    config.serverIp = this.$store.getters.getBimServerIp;
    config.appKey = this.$store.getters.getBimAppKey;
    config.appSecret = this.$store.getters.getBimAppSecret;
    this.data = new WINDData(config);
    let loadCallback = function (type, value) {//模型加载百分比回调
      console.log('load%:' + value);
    };
    this.data.addWINDDataCallback(1, loadCallback);
    let canvas = document.getElementById('View')
    this.view = new WINDView(canvas)
    this.view.bindWINDData(this.data)
    //PAN:平移  ROTATE:旋转  PICK:点选  默认为PICK
    this.view.getWINDViewRoaming().setLeftMouseOperation(this.LeftMouseOperation.PAN);
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">

.fabric-container {
  width: 100%
  height: 100%
  background-image url("../../assets/img/sm_backgroud.jpg")
  background-size 100% 100%
  background-repeat no-repeat
  overflow scroll
}

.fabric_mask {
  display: flex
  flex-direction column
  width 100%
  height 100%
  background-color #0D0E13B3
  z-index 999
}

.fab_title {
  width 100%
  height 5%
  display flex
  justify-content space-between
}

.el-radio-group {
  display block
  height 100%
  overflow auto
}

.el-radio-button {
}

.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color #44ACB7
  border 1px solid #AAAAAA
}

.el-radio-button__inner {
  font-size 1rem
  padding 4px
  width 7rem
  background-color #0C283A
  border 1px solid #AAAAAA
  color white
}

.el-radio-button:last-child .el-radio-button__inner
.el-radio-button:first-child .el-radio-button__inner {
  border-radius 0
}

.one_top_left {
  width 45%
  height 100%
  display flex
  flex-direction column
}

.one_top_right {
  width 53%
  margin-left 1%
  height 100%
  background-color #44ACB7
  display flex
  flex-direction column
}

.one_top_right_title {
  height 10%
  margin-left 10px
  display flex
  align-items center
}

.fab_title .el-dropdown {
  padding: 0;
  border-radius: 0;
  display: block;
}

.one_top_right_title .el-select {
  padding: 0;
  border-radius: 0;
  display: block;
  background-color transparent
}

.one_top_right_title .el-input__inner {
  width 200px
  background-color transparent
  border none
}

.one_top_right_title .el-select .el-input .el-select__caret {
  color #606266
  font-size: 1rem;
  position: absolute;
  right: 0.2rem;
}

.one_top_right_title .el-button {
  padding: 0.2rem;
  margin: 0;
  border-radius 0.1
}

.el-icon-arrow-down {
  font-size: 1rem;
  position: absolute;
  right: 0.2rem;
}

.one_top_right_content {
  width 100%
  height 90%
}

.one_bottom {
  width 100%
  height 42%
  display flex
  flex-direction column
  background-color #0C283AC5
}

.one_bottom_legends {
  width 100%
  height 20%
  display flex
  align-items center
  justify-content center
  flex-wrap wrap
}

.legend_item {
  height 50%
  display flex
  align-items center
  margin-left 1rem
}

.legend_icon {
  width 1rem
  height 1rem
}

.legend_text {
  margin-left 0.2rem
  font-size 1rem
  color white
}

.one_bottom_charts {
  width 100%
  height 80%
  display flex
  overflow auto
}

.chart_item {
  min-height 13rem
  min-width 15rem
  max-width 15rem
  max-height 13rem
}

.two_top {
  width 100%
  height 55%
  display flex
  flex-wrap wrap
  overflow auto
}

.two_bottom {
  width 100%
  height 43%
  margin-top 2%
  overflow auto
}

.three_left {
  width 49%
  height 100%
}

.three_right {
  width 49%
  height 100%
  margin-left 2%
  background-color #0C283AC5
}

.el-input {
  font-size 1rem
}
</style>



// WEBPACK FOOTER //
// src/components/fabrication/quality.vue